export const IS_HALLOWEEN = process.env.REACT_APP_SEASONAL_THEME === 'halloween';
